module.exports = __webpack_public_path__ + "img/Philip McCreadie.11f88eef.png";